// Minimal JWT decode/storage helpers, matching the pattern used by
// tmc-local-frontend/src/util/jwt.js (parse without a library, no verification --
// verification happens server-side on every request).

const STORAGE_KEY = 'abstractImages.auth.jwt';

// https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript-without-using-a-library
export const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const decoder = (c) => {
    const cVal = c.charCodeAt(0).toString(16);
    const sliceCode = (`00${cVal}`);
    const sliceMin2 = sliceCode.slice(-2);
    return `%${sliceMin2}`;
  };
  const jsonPayload = decodeURIComponent(atob(base64).split('').map(decoder).join(''));
  return JSON.parse(jsonPayload);
};

export const parseJwtDate = (num) => new Date(num * 1000);

export const getRawJwt = () => localStorage.getItem(STORAGE_KEY);

export const setRawJwt = (jwt) => localStorage.setItem(STORAGE_KEY, jwt);

export const clearRawJwt = () => localStorage.removeItem(STORAGE_KEY);
